class ListStores {
    constructor () {
        this.roles = document.querySelectorAll("input[name*='role']");
        this.stores = document.querySelector(".js-store-field");

        if (!this.roles || !this.stores) {
            return;
        }

        this.bind();
    }

    displayStores() {
        this.stores.classList.remove("d-n");
    }

    hideStores() {
        this.stores.classList.add("d-n");
    }

    toggleStores() {
        const el = document.querySelector("input[name*='role']:checked");
        const roleField = document.querySelector(".js-role-field");

        if ((el && el.value === "ROLE_CONCIERGE") || (roleField && roleField.innerText === "Concierge")) {
            this.displayStores();
            return;
        }
        this.hideStores();
    }

    bind () {
        document.addEventListener("DOMContentLoaded", this.toggleStores.bind(this));
        Array.from(this.roles).forEach((el) => {
            el.addEventListener("change", this.toggleStores.bind(this));
        })
    }
}

export default ListStores;
